export const forgotPassword = "Forgot Password?";
export const createAccount = "Create An ITA Account.";
export const forgotPasswordConfirmationEmail1 = "An email has been sent to ";
export const forgotPasswordConfirmationEmail2 = " with a link to set your password.";
export const forgotPasswordConfirmationText = "If you don't receive the email \
  within a few minutes, please check the junk/spam folder of your email account.";

export const clickHereMessage = "Click here to go back to login page";



/** WEBPACK FOOTER **
 ** ./src/constants/loginText.js
 **/